export default {
    importSubUser_title: 'Import Users',
    importSubUser_button: 'Import',
    importSubUser_cancel: 'Cancel',
    importSubUser_semicolon: 'Semicolon (;)',
    importSubUser_comma: 'Comma (,)',
    importSubUser_selectDelimiter: 'Select',
    importSubUser_delimiter: 'Delimiter',
    importSubUser_started: 'Import started successfully',
    importSubUser_completed: 'Import completed successfully',
    importSubUser_error_required: 'File is required',
    importSubUser_error_delimiter: 'Delimiter is required',
    importSubUser_downloadTemplate: 'Download Template',
    importSubUser_file: 'File',
    importSubUser_chooseFile: 'Choose File',
    importSubUser_support_message: 'Only CSV format supported',
    importSubUser_max: 'Max',
    importSubUser_maxSizeFile: 'Maximum file size: 5MB',
    importSubUser_instructions: 'Important Note: The ID, Username and Email columns are required for updates but cannot be modified. They must match the existing user records; This feature does not support user creation at the moment. Please, perform a table export without editing the ID column value to maintain record reference.',
    users_import_error_US01: 'Empty CSV file: The file contains no data rows. Please add at least one row with user information.',
    users_import_error_US02: 'Error in CSV format: ID column is required for user updates.',
    users_import_error_US03: 'No valid data rows found: ID, Name, Last Name, Email, Username, Role, Tags columns cannot be empty in all rows.',
};